import { useCallback } from 'react';
import deepmerge from "deepmerge";
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";

import { getProperty } from "../utils/FPEUtils";

const useStyles = (props={}) => makeStyles(deepmerge({}, props))();

const CustomTable = (props) => {
  const { columns, rows, onMouseLeave, onMouseOver, onClick, classes, ...other } = props;

  const handleMouseLeave = useCallback(() => {
    if (onMouseLeave) {
      onMouseLeave();
    }
  }, [onMouseLeave]);

  const handleMouseOver = useCallback((data) => {
    if (onMouseOver) {
      onMouseOver(data);
    }
  }, [onMouseOver]);

  const handleClick = useCallback((data) => {
    if (onClick) {
      onClick(data);
    }
  }, [onClick]);

  const _classes = useStyles(classes);
  const {t} = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table className={_classes.table} {...other}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align}>{t(column.label)}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody onMouseLeave={handleMouseLeave}>
          {rows.map((data, index) => {
            return (
              <TableRow hover tabIndex={-1} key={index+1}
                onMouseOver={() => handleMouseOver(data)}
                onClick={() => handleClick(data)}
              >
                {columns.map((column) => {
                  if (column.render) {
                    return column.render(data, column);
                  } else {
                    let value = getProperty(data, column.key);
                    if (column.formatter) {
                      value = column.formatter(value);
                    }
                    return (
                      <TableCell key={column.id} align={column.align} style={column.style} title={column.title ? value : ""}>{value}</TableCell>
                    );
                  }
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CustomTable;
